import ClipboardButtons from './ClipboardButtons';
import './ClipboardButtons.scss';

export default ClipboardButtons;
